export default "__VITE_ASSET__C6ajial5__"